import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import MainLayout from './components/MainLayout';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPanel from './components/AdminPanel';
import PrivateRoute from './components/PrivateRoute';
import ScrollToTop from './components/ScrollToTop';
import Preloader from './components/Preloader';
import Interview from './pages/Interview';
import './App.css';
import './i18n';

// Loading fallback for Suspense (can be kept or removed if Preloader covers it)
const Loading = () => null;

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AnimatePresence mode='wait'>
        {loading && <Preloader key="preloader" />}
      </AnimatePresence>

      {!loading && (
        <Suspense fallback={<Loading />}>
          <Routes>
            {/* Main One-Page Route */}
            <Route path="/" element={<MainLayout />} />
            <Route path="/home" element={<Navigate to="/" replace />} />

            {/* Admin & Functional Routes */}
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<Navigate to="/admin-login" replace />} />
            <Route path="/admin-panel" element={<PrivateRoute element={<AdminPanel />} />} />
            <Route path="/interview" element={<Interview />} />

            {/* Legacy Route Redirects (optional, for SEO if needed, or just catch-all) */}
            <Route path="/aboutus" element={<Navigate to="/" replace />} />
            <Route path="/contactus" element={<Navigate to="/" replace />} />
            <Route path="/academic" element={<Navigate to="/" replace />} />
            {/* <Route path="/newsfeed" element={<Navigate to="/" replace />} /> */}

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      )}
    </Router>
  );
};

export default App;
